import type {
  ChangeRequestPayload,
  LatestFormResponse,
} from '@contracts/changeRequest/ChangeRequestContract';
import { AuthenticatedClient } from '@src/common/services/AuthenticatedClient';
import { PermitInstruction } from '@src/orders/domain/PermitInstruction';

export const ChangeRequestClient = {
  createChangeRequest: async ({
    orderId,
    reason,
    form,
    dirtyFields,
  }: ChangeRequestPayload): Promise<void> => {
    return await AuthenticatedClient.post(`/change-request`, {
      orderId,
      reason,
      form,
      dirtyFields,
    });
  },

  getOrderLatestForm: async (
    orderId: string,
  ): Promise<{
    fields: string[];
    permitInstructions: PermitInstruction[];
  }> => {
    const response = await AuthenticatedClient.get<LatestFormResponse>(
      `/change-request/order/${orderId}/latestForm`,
    );
    return {
      fields: response.data.fields,
      permitInstructions: response.data.permitInstructions.map(
        (instructionAttributes) => new PermitInstruction(instructionAttributes),
      ),
    };
  },
};
